







































import { Component, Watch, Mixins, Prop, Emit } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import BaseMixin from '../../mixins/BaseMixin';
import _ from 'lodash/fp';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import PartListItem from '@/components/part-search/PartListItem.vue';

@Component({
    components: {
        PartListItem,
    },
})
export default class SearchablePartsList extends Mixins(BaseMixin) {
    @Prop(String)
    private title!: string;
    @Prop(String)
    private partActionLink!: string;
    @Prop(String)
    private showPartImages!: boolean;
    @Prop(Array)
    private parts!: PartSearchResultDetails[];

    @Prop({ default: false })
    private showAdditionalPartsLink!: boolean;
    @Prop({ required: false })
    private linkToAdditionalParts!: string;

    @Prop({ default: false })
    private showCustomPartLength!: boolean;
    @Prop({ required: false, default: 0 })
    private customPartLength!: number;

    private searchTerm: string = '';

    private get partsLength(): number {
        return this.showCustomPartLength ? this.customPartLength : this.parts.length;
    }

    private searchTermChangedDebounced: () => void = _.debounce(500, () => {
        this.emitSearchTermChangedEvent();
    });

    @Watch('searchTerm')
    private onSearchTextChanged(): void {
        this.searchTermChangedDebounced();
    }

    @Emit('search-term-changed')
    private emitSearchTermChangedEvent(): string {
        return this.searchTerm;
    }
}
